import { useTranslation } from "react-i18next";
import DoorIcon from "../../Assets/Icons/DoorBasic.svg";
import GarageDoorIcon from "../../Assets/Icons/GarageDoorIcon.svg";

// TODO: These should be fetched from api
export const DOOR_TYPES = () => {
	const { t } = useTranslation();

	return [
		{
			id: "door",
			name: t("door_types.door"),
			image: DoorIcon
		},
		{
			id: "garage_door",
			name: t("door_types.garage_door"),
			image: GarageDoorIcon
		},
		{
			id: "barrier",
			name: t("door_types.barrier"),
			image: GarageDoorIcon
		}
	];
};
